import { render } from "./modal.vue?vue&type=template&id=0e22cb30&scoped=true&ts=true"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"

import "./modal.vue?vue&type=style&index=0&id=0e22cb30&lang=less&scoped=true"
import "./modal.vue?vue&type=style&index=1&id=0e22cb30&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e22cb30"]])

export default __exports__